export const uiRedux = {
  HeaderSize: "UI/HEADER-SIZE",
  FooterSize: "UI/FOOETR-SIZE",
  Width: "UI/WIDTH",
  Height: "UI/HEIGHT",
  Scroll: "UI/SCROLL",
  Drawer: "UI/DRAWER",
  Contact: "UI/Contact",
};
